import { useTranslation } from "react-i18next";

interface ComparisonRow {
  featureKey: string;
  usKey: string;
  otherKey: string;
}

const comparisonRows: ComparisonRow[] = [
  { featureKey: "comparison.row1", usKey: "comparison.row1_us", otherKey: "comparison.row1_other" },
  { featureKey: "comparison.row2", usKey: "comparison.row2_us", otherKey: "comparison.row2_other" },
  { featureKey: "comparison.row3", usKey: "comparison.row3_us", otherKey: "comparison.row3_other" },
  { featureKey: "comparison.row4", usKey: "comparison.row4_us", otherKey: "comparison.row4_other" },
  { featureKey: "comparison.row5", usKey: "comparison.row5_us", otherKey: "comparison.row5_other" },
];

export default function ComparisonSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 text-center mb-10">
          {t("comparison.title")}
        </h2>

        <div className="overflow-x-auto rounded-2xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-6 py-4 font-semibold text-foreground-800">
                  {t("comparison.feature")}
                </th>
                <th className="text-center px-6 py-4 font-semibold text-primary-700 bg-primary-50/50">
                  {t("comparison.us")}
                </th>
                <th className="text-center px-6 py-4 font-semibold text-foreground-600">
                  {t("comparison.others")}
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map((row, idx) => (
                <tr
                  key={row.featureKey}
                  className={`border-t border-background-200/70 ${
                    idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"
                  }`}
                >
                  <td className="px-6 py-3.5 text-foreground-800 font-medium">{t(row.featureKey)}</td>
                  <td className="px-6 py-3.5 text-center text-primary-700 font-medium bg-primary-50/30">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-check-line text-primary-500"></i>
                      {t(row.usKey)}
                    </span>
                  </td>
                  <td className="px-6 py-3.5 text-center text-foreground-500">
                    {t(row.otherKey)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}